import { Link } from "@inertiajs/react"
import { MapPin } from "lucide-react"

export function ArticleCard({ article }) {
  const { title, slug, excerpt, featuredImageUrl, publishedAt, category, author, city, state, country } = article

  const location = [city, state, country && country !== "US" ? country : null].filter(Boolean).join(", ")

  const formattedDate = publishedAt
    ? new Date(publishedAt).toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "numeric",
      })
    : null

  return (
    <Link
      href={`/collective/${category.slug}/${slug}`}
      className="group block bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
    >
      {/* Image */}
      <div className="aspect-[2/1] relative overflow-hidden bg-zinc-100">
        {featuredImageUrl ? (
          <img
            src={featuredImageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-kf-red/20 to-kf-red/5 flex items-center justify-center">
            <span className="text-kf-red/40 font-display text-2xl">KF</span>
          </div>
        )}
        {/* Category badge */}
        <span className="absolute top-3 left-3 px-3 py-1 bg-kf-red text-white text-xs font-semibold uppercase tracking-wider">
          {category.name}
        </span>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="font-display text-lg text-zinc-900 mb-2 group-hover:text-kf-red transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-zinc-600 text-sm mb-4 line-clamp-2">{excerpt}</p>

        {/* Meta */}
        <div className="flex items-center justify-between text-sm text-zinc-500">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full overflow-hidden bg-kf-gradient flex items-center justify-center flex-shrink-0">
              {author.headshotUrl ? (
                <img
                  src={author.headshotUrl}
                  alt={author.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              ) : (
                <span className="text-white text-[10px] font-display">
                  {author.name?.charAt(0) || "K"}
                </span>
              )}
            </div>
            <span>{author.name}</span>
            {location && (
              <span className="flex items-center gap-1 text-zinc-400">
                <MapPin className="w-3 h-3" />
                {location}
              </span>
            )}
          </div>
          {formattedDate && <span>{formattedDate}</span>}
        </div>
      </div>
    </Link>
  )
}
